const API_URL = process.env.REACT_APP_BACKEND_URL + '/api';

export const fetchRecommendations = async (assetType = null) => {
  const url = assetType && assetType !== 'all' 
    ? `${API_URL}/recommendations?asset_type=${assetType}`
    : `${API_URL}/recommendations`;
  const res = await fetch(url);
  return res.json();
};

export const fetchRecommendationStats = async () => {
  const res = await fetch(`${API_URL}/recommendations-stats`);
  return res.json();
};

export const fetchRecommendationHistory = async () => {
  const res = await fetch(`${API_URL}/recommendations-history`);
  return res.json();
};

export const fetchRecommendationPerformance = async () => {
  const res = await fetch(`${API_URL}/recommendations-performance`);
  return res.json();
};

export const createStripeCheckout = async (planId, successUrl, cancelUrl, email = null) => {
  const res = await fetch(`${API_URL}/stripe/create-checkout`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      plan_id: planId,
      success_url: successUrl,
      cancel_url: cancelUrl,
      customer_email: email
    })
  });
  return res.json();
};

export const fetchStripePlans = async () => {
  const res = await fetch(`${API_URL}/stripe/plans`);
  return res.json();
};

export default API_URL;
